import axios from 'axios'

import { refreshToken } from '../services/refreshToken'
import { logout, redirectToDefaultModulo } from '../services/session'

import { bearerTokenHeader, empresaToken } from './authorizationHeader'

import { getUrl } from './config'
import { getAuth, getRouter, getDefaultModulo } from '../contexts/global'
import InvalidSession from '../errors/InvalidSession'

const api = axios.create({
  baseURL: getUrl(),
  timeout: 120000
})

api.interceptors.request.use(requestBefore)
api.interceptors.response.use(undefined, responseError)

const refreshTokenFn = refreshToken()

async function requestBefore(config) {
  const token = window.localStorage.getItem('wisepay-token')
  const tokenEmpresa = window.localStorage.getItem('wisepay-empresa')

  const hasAuthHeader = Boolean(config.headers?.authorization)
  const hasEmpresaHeader = Boolean(config.headers?.['token-empresa'])

  if (token && !hasAuthHeader) {
    const currentToken = await refreshTokenFn(token)

    if (!currentToken) {
      logoutAndThrow()
    }
  }

  return {
    ...config,
    headers: {
      ...config.headers,
      ...(!hasAuthHeader && token ? bearerTokenHeader(token) : {}),
      ...(!hasEmpresaHeader && tokenEmpresa ? empresaToken(tokenEmpresa) : {}),
      'type-application': 'web'
    }
  }
}

function responseError(error) {
  const { response } = error

  if (!response) {
    return Promise.reject(error)
  }

  const requestUrl = response.config?.url
  const ignoredUrls = ['login', '/termo-de-uso']

  if (!ignoredUrls.includes(requestUrl)) {
    const status = response.status

    if (status === 401) {
      logout({
        auth: getAuth(),
        history: getRouter(),
        invalidSession: true
      })
    }

    if (status === 403) {
      redirectToDefaultModulo({
        defaultModulo: getDefaultModulo(),
        history: getRouter()
      })
    }
  }

  return Promise.reject(error)
}

function logoutAndThrow() {
  logout({
    auth: getAuth(),
    history: getRouter(),
    invalidSession: true
  })
  throw new InvalidSession()
}

// function getErrorMessage (error) {
//   if (
//     error.response &&
//     error.response.data &&
//     typeof error.response.data.error === 'string'
//   ) {
//     return error.response.data.error
//   }
//   return null
// }

export default api
